import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getInputFieldNameValue } from "utils/commonMethods";
import { ASCII_CODES, KEY_CODES, OTP_LENGTH } from "constants/constants";
import OtpInputBox from "components/OtpSelector/OtpInputBox/OtpInputBox";
import "components/OtpSelector/OtpSelector.css";

function OtpSelector({ digits = OTP_LENGTH, onChange }) {
  const inputBoxes = Array(digits).fill("");
  const OTP_PLACEHOLDER = "-";

  const getInputName = function (index) {
    return `digit${index}`;
  };

  const initialState = {};

  inputBoxes.forEach((element, index) => {
    initialState[getInputName(index)] = "";
  });

  //Initializes state according to number of digits required.
  //Example : For four digits, {digit0:null,digit1:null,digit2:null}
  const refs = {};

  const [state, setState] = useState(initialState);

  useEffect(() => {
    let finalOtp = Object.values(state).reduce((accumulator, digit) => {
      return accumulator + "" + digit;
    }, "");

    return onChange(Number(finalOtp));
  }, [state, onChange]);

  //Focus an input box.
  const focusInputBox = function (index) {
    if (index < 0 || index >= digits) {
      return;
    }
    return refs[getInputName(index)].current.focus();
  };

  //Focus last input box if user hits backspace key when there is no value inside current input box.
  const handleLastInputBoxFocus = function (ev, index) {
    const { value } = getInputFieldNameValue(ev);

    if (!value && ev.key === KEY_CODES.BACKSPACE) {
      return focusInputBox(index - 1);
    }

    //If input box has value, focus next input box.
    if (
      value !== "" &&
      ev.key !== KEY_CODES.BACKSPACE &&
      ASCII_CODES.NUMBERS.includes(ev.keyCode) &&
      refs[getInputName(index + 1)]
    ) {
      refs[getInputName(index + 1)].current.value = "";
      return focusInputBox(index + 1);
    }
  };

  //Sets value into state.
  const setDigitToState = function (ev, index) {
    //Allow one digit to be entered only.
    if (ev.target.value.length > 1) {
      return;
    }

    const { name, value } = getInputFieldNameValue(ev);
    return setState({ ...state, [name]: value });
  };

  const initializeRef = function (inputName, ref) {
    return (refs[inputName] = ref);
  };

  return (
    <div className="otp-inputs">
      {inputBoxes.map((element, index) => {
        return (
          <div className="otp-input__wrapper" key={index}>
            <OtpInputBox
              type="number"
              value={state[getInputName(index)]}
              initRef={(ref) => initializeRef(getInputName(index), ref)}
              onChange={(ev) => setDigitToState(ev, index)}
              onKeyDown={(ev) => handleLastInputBoxFocus(ev, index)}
              name={getInputName(index)}
              id={getInputName(index)}
              placeholder={OTP_PLACEHOLDER}
              key={index}
            />
          </div>
        );
      })}
    </div>
  );
}

OtpSelector.propTypes = {
  digits: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default OtpSelector;
